module.exports = __webpack_public_path__ + "img/img_14.9b0aa38b.png";